<div
  class="flex--column flex--justify-center catalog-product-description"
  [class]="disabled ? 'catalog-product-description--disabled' : 'catalog-product-description--enabled'"
>
  <span class="text--default">{{ catalogItem.description }}</span>
  <span class="catalog-product-description__label">
    {{ 'product.search.table.article-number' | translate: { articleNumber: catalogItem.entryId } }}
  </span>
</div>
